import { useLocation } from "react-router-dom";
import { useSafeNavigate } from "@/hooks/useSafeNavigate";
import { useEffect } from "react";
import { ChevronLeft } from "lucide-react";
import poodleBenchImg from "@/assets/poodle_bench.webp";
import { createTraceId, logger } from "@/lib/services";

const NotFound = () => {
  const location = useLocation();
  const navigate = useSafeNavigate();

  useEffect(() => {
    logger.error("404 Error: User attempted to access non-existent route", {
      context: { feature: "routing", function_name: "NotFound", screen_id: "SYS-404", trace_id: createTraceId() },
      data: { path: location.pathname },
      allowList: ["path"],
      error_code: "route_not_found",
      error_type: "ui",
    });
  }, [location.pathname]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleTelegramClick = () => {
    window.open("https://t.me/drugtech_bot", "_blank");
  };

  return (
    <div className="min-h-screen min-h-[100dvh] flex flex-col bg-bg-accent-pink-soft">
      {/* Mobile container */}
      <div
        className="w-full flex flex-col min-h-screen min-h-[100dvh]"
        style={{
          maxWidth: "375px",
          margin: "0 auto",
        }}
      >
        {/* Header */}
        <div
          className="flex items-center px-4 py-4 bg-bg-primary"
          style={{ minHeight: "56px" }}
        >
          <button
            onClick={handleBack}
            className="w-10 h-10 flex items-center justify-center -ml-2"
            aria-label="Назад"
          >
            <ChevronLeft className="w-6 h-6 text-text-primary" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 bg-bg-primary px-4 pb-8 flex flex-col items-center justify-center">
          {/* Image */}
          <div className="mb-8">
            <img
              src={poodleBenchImg}
              alt="Пудель на скамейке"
              className="w-64 h-auto object-contain"
            />
          </div>

          {/* 404 Text */}
          <h1
            className="text-text-primary text-center mb-2"
            style={{
              fontFamily: "CoFo Gothic, sans-serif",
              fontWeight: 900,
              fontSize: "48px",
              lineHeight: "100%",
            }}
          >
            404
          </h1>

          <p
            className="text-text-primary text-center mb-2"
            style={{
              fontFamily: "CoFo Gothic, sans-serif",
              fontWeight: 700,
              fontSize: "20px",
              lineHeight: "140%",
            }}
          >
            Ой, что-то пошло не так
          </p>

          <p
            className="text-text-secondary text-center mb-8"
            style={{
              fontFamily: "CoFo Gothic, sans-serif",
              fontWeight: 400,
              fontSize: "16px",
              lineHeight: "140%",
            }}
          >
            Страница не найдена
          </p>

          {/* Back to home button */}
          <button
            onClick={() => navigate("/")}
            className="w-full bg-bg-button-primary text-text-secondary transition-colors mb-6"
            style={{
              height: "52px",
              borderRadius: "20px",
              fontFamily: "CoFo Gothic, sans-serif",
              fontWeight: 500,
              fontSize: "16px",
            }}
          >
            На главную
          </button>

          {/* Help section */}
          <div className="text-center">
            <p
              className="text-text-tertiary mb-2"
              style={{
                fontFamily: "CoFo Gothic, sans-serif",
                fontSize: "14px",
                lineHeight: "140%",
              }}
            >
              Не нашли что искали?
              <br />
              Напишите нам — мы обязательно поможем.
            </p>
            <button
              onClick={handleTelegramClick}
              className="text-text-accent-pink underline"
              style={{
                fontFamily: "CoFo Gothic, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
              }}
            >
              Написать в Telegram
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
